export enum FormElementType {
    TEXT = "text",
    DATE = "date",
    FILE = "file",
    RANGE = "range",
    TOGGLE = "toggle",
    NUMBER = "number",
    SELECT = "select",
    CHECKBOX = "checkbox",
    DATE_TIME = "date_time",
    TEXT_AREA = "text_area",
    MULTI_SELECT = "multi_select",
}

export default function useFormElement() {
    return {
        //
    };
}